module.exports = __webpack_public_path__ + "static/img/own.ab110c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/own.png
// module id = cwhT
// module chunks = 1